export default __webpack_public_path__ + "static/media/home-background2.930be700.png";